import React, { FC } from "react";
// A customizable text area component for multiline text input with various props for styling and behavior.

interface TextAreaProps {
  id?: string;
  value?: string;
  rows?: number;
  cols?: number;
  name?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

const TextArea: FC<TextAreaProps> = ({
  id,
  value,
  name,
  rows = 2,
  cols = 30,
  onChange,
  onKeyDown,
  disabled = false,
  placeholder,
  className = "",
}) => {
  return (
    <textarea
      id={id}
      value={value}
      name={name}
      rows={rows}
      cols={cols}
      disabled={disabled}
      onChange={onChange}
      onKeyDown={onKeyDown}
      className={`form-control ${className}`}
      placeholder={placeholder}
    />
  );
};

export default TextArea;
